import { Link } from 'react-router-dom';
import { 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaWhatsapp, 
  FaYoutube, 
  FaArrowRight, 
  FaExternalLinkAlt, 
  FaHeart,
  FaBook,
  FaBriefcase,
  FaNewspaper
} from 'react-icons/fa';
import logo from '@assets/micropoint-favicon.jpg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="container mx-auto px-4 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          
          {/* ─── Company Info ─── */}
          <div>
            <Link to="/" className="flex items-center justify-center md:justify-start mb-4 hover:scale-105 transition-transform">
              <img 
                src={logo} 
                alt="Micropoint Systems" 
                className="h-12 w-auto rounded-lg object-contain" 
              />
            </Link>
            <p className="text-slate-600 text-sm text-center md:text-left leading-relaxed">
              Building secure financial software, ERP systems, payment integrations, 
              and mobile banking platforms trusted by organizations across Africa.
            </p>
            <div className="flex justify-center md:justify-start gap-2 mt-4">
              <SocialIcon href="#" icon={FaFacebook} label="Facebook" />
              <SocialIcon href="#" icon={FaTwitter} label="Twitter" />
              <SocialIcon href="#" icon={FaLinkedin} label="LinkedIn" />
              <SocialIcon href="#" icon={FaWhatsapp} label="WhatsApp" />
              <SocialIcon href="#" icon={FaYoutube} label="YouTube" />
            </div>
          </div>

          {/* ─── Solutions ─── */}
          <div>
            <h3 className="text-slate-900 font-bold text-sm uppercase tracking-wider text-center md:text-left">
              Solutions
            </h3>
            <ul className="space-y-2.5 mt-4 text-center md:text-left">
              <li><Link to="/products" className="text-slate-600 hover:text-blue-600 transition-colors text-sm flex items-center justify-center md:justify-start gap-2">
                <FaBriefcase className="text-blue-500 text-xs" /> Core Banking
              </Link></li>
              <li><Link to="/products" className="text-slate-600 hover:text-blue-600 transition-colors text-sm flex items-center justify-center md:justify-start gap-2">
                <FaBook className="text-blue-500 text-xs" /> ERP Solutions
              </Link></li>
              <li><Link to="/products/payment-integration-platform" className="text-slate-600 hover:text-blue-600 transition-colors text-sm flex items-center justify-center md:justify-start gap-2">
                <FaExternalLinkAlt className="text-blue-500 text-xs" /> Payment Integration
              </Link></li>
              <li><Link to="/products" className="text-slate-600 hover:text-blue-600 transition-colors text-sm flex items-center justify-center md:justify-start gap-2">
                <FaNewspaper className="text-blue-500 text-xs" /> Mobile Banking
              </Link></li>
            </ul>
          </div>

          {/* ─── Company ─── */}
          <div>
            <h3 className="text-slate-900 font-bold text-sm uppercase tracking-wider text-center md:text-left">
              Company
            </h3>
            <ul className="space-y-2.5 mt-4 text-center md:text-left">
              <li><Link to="/about" className="text-slate-600 hover:text-blue-600 transition-colors text-sm">About Us</Link></li>
              <li><Link to="/case-studies" className="text-slate-600 hover:text-blue-600 transition-colors text-sm font-medium text-blue-600 flex items-center justify-center md:justify-start gap-1.5">
                <span>📊</span> Case Studies <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full">Featured</span>
              </Link></li>
              <li><Link to="/partners" className="text-slate-600 hover:text-blue-600 transition-colors text-sm">Partners</Link></li>
              <li>
                <a 
                  href="https://micropointintern.lovable.app/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-600 hover:text-blue-600 transition-colors text-sm inline-flex items-center gap-1"
                >
                  Careers <FaExternalLinkAlt className="text-[10px]" />
                </a>
              </li>
              <li><Link to="/contact" className="text-slate-600 hover:text-blue-600 transition-colors text-sm">Contact</Link></li>
              <li><Link to="/demo" className="text-slate-600 hover:text-blue-600 transition-colors text-sm">Request Demo</Link></li>
            </ul>
          </div>

          {/* ─── Contact & Newsletter ─── */}
          <div>
            <h3 className="text-slate-900 font-bold text-sm uppercase tracking-wider text-center md:text-left">
              Contact
            </h3>
            <ul className="space-y-2.5 text-sm text-slate-600 text-center md:text-left mt-4">
              <li className="flex items-center justify-center md:justify-start gap-2 hover:text-blue-600 transition-colors group">
                <span className="group-hover:scale-110 transition-transform">📍</span> 
                <span>Nairobi, Kenya</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 hover:text-blue-600 transition-colors group">
                <span className="group-hover:scale-110 transition-transform">📞</span> 
                <span>+254 703 802 020</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 hover:text-blue-600 transition-colors group">
                <span className="group-hover:scale-110 transition-transform">✉️</span> 
                <a href="mailto:info@micropointsystems.com" className="hover:text-blue-600 transition-colors">
                  info@micropointsystems.com
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 hover:text-blue-600 transition-colors group">
                <span className="group-hover:scale-110 transition-transform">💬</span> 
                <span>WhatsApp: +254 703 802 020</span>
              </li>
            </ul>
            
            {/* Newsletter */}
            <div className="mt-6">
              <h4 className="font-semibold text-slate-900 text-sm mb-2.5 text-center md:text-left">
                Newsletter
              </h4>
              <div className="flex max-w-xs mx-auto md:mx-0">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3.5 py-2.5 text-sm border border-slate-300 rounded-l-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-slate-50/50 hover:bg-white"
                  aria-label="Email for newsletter"
                />
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-r-lg font-semibold transition-all hover:shadow-md flex items-center gap-1.5 text-sm whitespace-nowrap">
                  <span>Subscribe</span>
                  <FaArrowRight className="text-xs" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── Bottom Bar ─── */}
      <div className="border-t border-slate-200 bg-slate-50/30">
        <div className="container mx-auto px-4 max-w-7xl py-5">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-slate-600 gap-3">
            <span className="hover:text-blue-600 transition-colors text-center md:text-left">
              Copyright &copy; {currentYear} Micropoint Systems Ltd. All Rights Reserved.
            </span>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link to="/case-studies" className="text-blue-600 hover:text-blue-700 transition-colors text-xs font-medium flex items-center gap-1">
                <span>📊</span> Success Stories
              </Link>
              <Link to="/privacy" className="text-slate-500 hover:text-blue-600 transition-colors text-xs">Privacy Policy</Link>
              <Link to="/terms" className="text-slate-500 hover:text-blue-600 transition-colors text-xs">Terms of Service</Link>
              <Link to="/security" className="text-slate-500 hover:text-blue-600 transition-colors text-xs">Security</Link>
              <span className="text-slate-300">|</span>
              <span className="flex items-center gap-1 text-xs text-slate-400">
                Developed with <FaHeart className="text-red-500 text-[10px] animate-pulse" /> by
                <a 
                  href="https://jecthub.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-700 transition-colors font-medium inline-flex items-center gap-0.5"
                >
                  Jecthub <FaExternalLinkAlt className="text-[8px]" />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

// ─── Social Icon Component ──────────────────────────
function SocialIcon({ href, icon: Icon, label }) {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label={label}
      className="w-9 h-9 rounded-full bg-slate-100 hover:bg-blue-600 text-slate-600 hover:text-white flex items-center justify-center transition-all hover:scale-110 hover:shadow-md"
    >
      <Icon size={16} />
    </a>
  );
}